import React from 'react'
import { SvgIconProps } from '@mui/material/SvgIcon'
import { ContentCopy } from '@mui/icons-material'

const CopyIcon = (props: SvgIconProps) => {
  return <ContentCopy {...props} htmlColor="theme.palette['orange-900']" />
}

export default CopyIcon
